import React from 'react';
import pic from '../Assets/news1.jpg';
import pic1 from '../Assets/news2.jpg'; 
import right from "../Assets/illustration-right-cut.svg"
import { Parallax, ParallaxProvider } from 'react-scroll-parallax';
const cards = [
  {
    id: 1,
    image:  pic,
    name: "Ana",
    title: "Day Care ", 
    message: "A loving start for our youngest learners.Focus on sensory play, basic motor skills, and socialization in a secure and comforting setting"

  },
  {
    id: 2,
    image:  pic1,
    name: "John",
    title: "PlayGroup  ",
    message: "Encouraging exploration and interaction.Activities designed to develop language, coordination, and early social skills."
  },
  {
    id: 3,
    image: pic1,
    name: "Eve",
    title: " Pre-KG ",
    message: "Building a foundation for learning.Focus on creativity, self-expression, and basic literacy and numeracy concepts."
  },
  {
    id: 4,
    image: pic,
    name: "Lucy",
    title: "LKG",
    message: "Learning through play and discovery.Hands-on activities to foster problem-solving, collaboration, and curiosity."
  },
  {
    id: 5,
    image:  pic1,
    name: "Mike",
    title: "UKG",
    message: "Ready for school and beyond.Emphasis on critical thinking, confidence, and emotional resilience to prepare for formal education."
  },
  {
    id: 6,
    image: pic,
    name: "Sarah",
    title: "extracurriculars",
    message: "Something amazing is on its way! Get ready for an exciting new experience.  Stay connected for updates—coming soon to inspire and delight you!"
  }
];

const  Ages = () => {
  return (
    <ParallaxProvider>

    <div className=''>
       {/* < div  className=" relative ">
       {/* <Parallax  translateX={[-1, 1]}  > */}
         {/* <img src={right} alt="right"   className=' absolute right-0 lg:right-2  top-44 lg:top-0   z-30  ' /> */}
         {/* </Parallax> */}
      {/* </ div> */} 
      <div className='max-w-screen-xl mx-auto px-6'> 
    
     
    <div className="text-[#0a3039] bg-white py-8 px-4 lg:px-16">
  <Parallax 
    translateX={[2, -2]} 
    className=" md:text-[60px] text-[30px]  font-bold lg:pl-28 leading-tight"
  > 
    <strong>At Kalam Kids Kindergarten,</strong>
  </Parallax>
  <div className="mt-4">
    <h1 className="text-[#16bab1]nd text-base md:text-lg  navbar-link lg:text-xl pr-4 md:pr-8 lg:pr-16 font-semibold tracking-wide">
      We offer programs tailored to children aged <span className="text-[#e84c24]">1.5 years to 6 years</span>, 
      ensuring the right balance of <span className="italic">learning, play,</span> and <span className="italic">exploration</span> at every stage.
    </h1>
  </div>
</div>
      {/* Map through the cards array to render dynamic content with grid layout */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mt-16">
        {cards.map((card) => (
          <div key={card.id} className="bday-card transition-transform transform hover:scale-105">
            <div className="bday-decor--container">
              <div className="h-[240px] w-[310px] rounded-xl shadow-lg bg-white hover:shadow-xl transition-shadow duration-300">
                <img src={card.image} alt={`Birthday of ${card.name}`} className='w-full h-full rounded-t-xl object-cover'/>
                <div className='flex justify-center -mt-5'>
                  < button className='text-[#16bab1]enter font-medium  text-white  rounded-lg border px-4 py-2 border-[#16bab1] bg-[#16bab1]'>{card.title}</ button>
                </div>
              </div>
            </div>

            <div className="bday-message bday-message--paper p-4 bg-[#f9f9f9] rounded-b-xl shadow-inner">
              <p className='text-gray-700'>{card.message}</p>
              {/* <p className="bday-decor bday-decor--bottom-right zoom-left-in-out">🎉</p> */}

            </div>
          </div>
        ))}
      </div>
      </div>
    </div>
    </ParallaxProvider>
  );
};

export default Ages;